/* Native details work without JavaScript; add keyboard and outside-click dismissal. */
(() => {
 const dismiss = (except) => document.querySelectorAll('.hkg-shell details[open]').forEach(d => {if (!except || (!d.contains(except) && d !== except)) d.open = false;});
 const positionMobileMenu = menu => {
  const shell = menu.closest('.hkg-shell');
  const top = Math.max(0, Math.round(shell?.getBoundingClientRect().bottom || 0));
  menu.style.setProperty('--hkg-mobile-menu-top', `${top}px`);
 };
 const updateMobileMenu = menu => {
  if (!menu.matches('.hkg-mobile-menu')) return;
  if (menu.open) positionMobileMenu(menu);
  document.body.classList.toggle('hkg-menu-open', menu.open);
  const trigger = menu.querySelector(':scope > summary');
  trigger?.setAttribute('aria-expanded', String(menu.open));
  trigger?.setAttribute('aria-label', menu.open ? 'Close navigation menu' : 'Open navigation menu');
 };
 document.addEventListener('click', e => {
  const openMobile = document.querySelector('.hkg-mobile-menu[open]');
  if (openMobile && !openMobile.contains(e.target)) openMobile.open = false;
  else if (!e.target.closest('.hkg-shell')) dismiss();
 });
 document.addEventListener('click', e => {
  const link = e.target.closest('.hkg-mobile-panel a');
  if (link) link.closest('.hkg-mobile-menu').open = false;
 });
 document.addEventListener('keydown', e => {if(e.key === 'Escape'){const open=[...document.querySelectorAll('.hkg-shell details[open]')];const last=open.at(-1);if(last){last.open=false;last.querySelector('summary')?.focus();}}});
 document.addEventListener('toggle', e => {
  if(e.target.matches('.hkg-desktop-nav details') && e.target.open) dismiss(e.target);
  updateMobileMenu(e.target);
 }, true);
 window.addEventListener('resize', () => {
  const openMobile = document.querySelector('.hkg-mobile-menu[open]');
  if (openMobile) positionMobileMenu(openMobile);
 });
})();
